import React, { useContext } from 'react';
import { Context } from '../../index';
import FileUpload from '../upload/FileUpload';
import './styles.css';

function UploadForm({ activLoad }) {
  const { uploadStore } = useContext(Context);

  const handleUpload = async (file: File) => {
    const url = await uploadStore.uploadAvatar(file);
    if (url) {
      activLoad(); // обновить аватар
    }
    // Ошибки можно обработать через uploadStore.error, если нужно
  };

  return (
    <div className="upload_container">
      <FileUpload
        onUpload={handleUpload}
        aspect={1}
        cropShape="round"
      >
        <div className="custom-file-button">
          {uploadStore.isUploading ? 'Загрузка...' : 'Выбрать фото'}
        </div>
      </FileUpload>

      {uploadStore.isUploading && <div className="upload-loading">Загрузка...</div>}
    </div>
  );
}

export default UploadForm;
